import { render, staticRenderFns } from "./EnvSettings.vue?vue&type=template&id=052973ca"
import script from "./EnvSettings.vue?vue&type=script&lang=ts"
export * from "./EnvSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports